import swirlBottomLeft from '@assets/images/common/swirl-bottom-left.svg';
import swirlTopRight from '@assets/images/common/swirl-top-right.svg';
import { CobaltLink } from '@cae/cobalt-react/components/link';
import { CobaltLogo } from '@cae/cobalt-react/components/logo';
import { CobaltIconHelpCircleOutline } from '@cae/cobalt-react/icons/outline/CobaltIconHelpCircleOutline';
import { FeedbackContent } from '@shared/components/feedback-content/FeedbackContent';
import { navigateToHelp } from '@shared/helpers/navigate-to-help/navigateToHelp';
import * as React from 'react';

import type { MaintenancePageProps } from './MaintenancePage.types';

import { MaintenanceIllustration } from './illustration/MaintenanceIllustration';
import styles from './MaintenancePage.module.css';

const MaintenancePage = React.memo(
  ({ flag }: Readonly<MaintenancePageProps>): React.ReactElement => {
    const handleAction = React.useCallback((): void => {
      if (flag.action) {
        globalThis.open(flag.action.url, '_blank', 'noopener,noreferrer');
      }
    }, [flag.action]);

    return (
      <div className={styles.maintenancePage} data-testid="maintenance-page">
        <img
          src={swirlTopRight}
          alt=""
          aria-hidden="true"
          className={styles.swirlTopRight}
        />
        <img
          src={swirlBottomLeft}
          alt=""
          aria-hidden="true"
          className={styles.swirlBottomLeft}
        />

        <header className={styles.header} data-testid="maintenance-header">
          <CobaltLogo size="medium" color="white" />

          <CobaltLink
            variant="inverse"
            onClick={navigateToHelp}
            className={styles.helpButton}
          >
            <CobaltIconHelpCircleOutline />
            Help
          </CobaltLink>
        </header>

        <h1
          className={`${styles.appTitle} heading-05`}
          data-testid="maintenance-app-title"
        >
          CAE Connect
        </h1>

        <div className={styles.content}>
          <FeedbackContent
            title={flag.title}
            message={flag.message}
            illustration={<MaintenanceIllustration />}
            primaryActionLabel={flag.action?.label}
            onPrimaryAction={flag.action ? handleAction : undefined}
            showPrimaryAction={Boolean(flag.action)}
            showSecondaryAction={false}
          />
        </div>

        <footer
          className={`${styles.footer} body-01`}
          data-testid="maintenance-footer"
        >
          &copy;{new Date().getFullYear()}, CAE Inc. All rights reserved.
        </footer>
      </div>
    );
  }
);

MaintenancePage.displayName = 'MaintenancePage';

export { MaintenancePage };
